import { render, staticRenderFns } from "./Edition.vue?vue&type=template&id=1f137b1a&"
import script from "./Edition.vue?vue&type=script&setup=true&lang=js&"
export * from "./Edition.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports